import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MultiselectAdvanced from 'components/ui/MultiselectAdvanced';

import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';

import {
  getPropertiesForMultiselect,
  getPropertyFiltersForMultiselect,
  getPropertiesForReview,
} from './store/actions';

const PropertyMultiselectAdvanced = ({
  properties,
  selectablePropertyIds,
  filters,
  getPropertiesForMultiselect,
  getPropertyFiltersForMultiselect,
  getPropertiesForReview,
  isFetchingReview,
  propertiesForReview,
  onChange,
  name,
  value,
  error,
}) => {
  useEffect(() => {
    getPropertiesForMultiselect();
    getPropertyFiltersForMultiselect();
  }, [getPropertiesForMultiselect, getPropertyFiltersForMultiselect]);

  const options = useMemo(() => {
    if (!selectablePropertyIds) return properties;
    return properties.filter((p) => selectablePropertyIds.includes(p.attributes.id));
  }, [properties, selectablePropertyIds]);

  const verbiage = {
    selectOptionsVerbiage: (propertiesSelected) =>
      getTranslatedString('landlordPortal.propertyMultiselectAdvanced.selected', {
        count: propertiesSelected.length,
      }),
    selectTitle: getTranslatedString('landlordPortal.multiselectAdvanced.selectProperties'),
    reviewTitle: getTranslatedString('landlordPortal.multiselectAdvanced.selectProperties'),
    optionTitle: getTranslatedString('landlordPortal.multiselectAdvanced.properties'),
  };

  const filterOption = (input, option) => {
    // TODO: Frontend filtering v.s. backend filtering
    const desiredPropertyOption = deepDiver(option, 'props.children');
    if (!desiredPropertyOption) return;

    return desiredPropertyOption.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };
  return (
    <MultiselectAdvanced
      options={options}
      filterOptions={filters}
      verbiage={verbiage}
      placeholder={getTranslatedString('landlordPortal.propertyMultiselectAdvanced.searchSelect')}
      size="large"
      filterOption={filterOption}
      handleFilter={getPropertiesForMultiselect}
      fetchReviewState={getPropertiesForReview}
      fetchingReviewState={isFetchingReview}
      reviewStateOptions={propertiesForReview}
      onChange={onChange}
      name={name}
      value={value}
      error={error}
    />
  );
};

const mapStateToProps = (store) => ({
  properties: store.landlord.properties.propertyMultiselect.properties,
  filters: store.landlord.properties.propertyMultiselect.filters,
  isFetchingReview: store.landlord.properties.propertyMultiselect.isFetchingReview,
  propertiesForReview: store.landlord.properties.propertyMultiselect.propertiesForReview,
});

const mapDispatchToProps = {
  getPropertiesForMultiselect,
  getPropertyFiltersForMultiselect,
  getPropertiesForReview,
};

PropertyMultiselectAdvanced.propTypes = {
  selectablePropertyIds: PropTypes.arrayOf(PropTypes.number),
};
PropertyMultiselectAdvanced.defaultProps = {
  selectablePropertyIds: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyMultiselectAdvanced);
